// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GBVz","signatureBlock":"Footer_signatureBlock__3eMuH","signature":"Footer_signature__BTyPo"};